import Layout from '@/layout/default'

import Document from '@/views/document/Document'
import NoPage from '@/views/errorpage/404'

import {
  getModuleList,
  getModuleListAuth,
  checkMenuAuth
} from "@/api/authority";
import {
  GetReviewBindingEnterpriseByUserID
} from "@/areas/PersonalCenter/api/Center";
import {
  asyncRouters,
  constantRouters,
  route404
} from '@/router'

//导入组件
export const loadView = (view) => {
  if (view) {
    if (view.startsWith('/areas')) {
      view = view.replace('/areas', '')
      return (resolve) => require([`@/areas${view}`], resolve)
    } else if (view.startsWith('/views')) {
      view = view.replace('/views', '')
      return (resolve) => require([`@/views${view}`], resolve)
    }

  } else {
    return NoPage
  }
};



const state = {
  routes: [],
  addRoutes: [],
  authOrgData: [],
  authButtons: [],
  moduleID: '', //菜单id
  hasAuthorized: false,
}

const mutations = {
  mSetRouters: (state, routes) => {
    state.addRoutes = routes
    state.routes = constantRouters.concat(routes)
  },
  mRemoveRouters: (state) => {
    state.routes = [];
  },
  //设置菜单ID
  mSetModuleID(state, value) {
    state.moduleID = value;
  },
  //设置是否加载过路由
  mSetHasAuthorized(state, value) {
    state.hasAuthorized = value;
  },
  //设置当前菜单按钮
  mSetAuthButtons(state, value) {
    state.authButtons = value;
  },
  //设置当前菜单的数据权限
  mSetAuthOrgData(state, value) {
    state.authOrgData = value;
  },
}

const actions = {
  aRemoveRouters({
    commit
  }) {
    commit('mRemoveRouters')
    commit('mSetHasAuthorized', false)
  },
  aGetRouters({
    commit
  }) {
    commit('mSetHasAuthorized', true)

    return new Promise(resolve => {
      getModuleList().then(res => {
        let menus = [];
        let open;
        if (res.Code === 200) {
          const data = res.Data;
          if (data.length > 0) {
            getRouterData(data);
            open = routerArr;
          }
          // let doc = data.filter(item => {
          //   return item.Type === 4
          // }).map(item => {
          //   return {
          //     path: '/' + item.ID,
          //     name: item.ID,
          //     meta: {
          //       menuID: item.ID,
          //       title: item.Name,
          //       menuID: item.ID,
          //       needAuth: true
          //     },
          //     component: Document
          //   }
          // })
          menus = [...open, {
            path: '/top1',
            component: Layout,
            // children: [...noopen, ...doc]
            // children: [...doc]
          }]
        }
        let accessedRoutes = [...asyncRouters, ...menus, ...route404]
        commit('mSetRouters', accessedRoutes)
        resolve(accessedRoutes)
      }).catch(error => {
        let accessedRoutes = [...asyncRouters, ...route404]
        commit('mSetRouters', accessedRoutes)
        resolve(accessedRoutes)
      })

    })
  },
  //检查菜单授权
  aCheckMenuAuth({
    commit
  }, menuId) {
    return new Promise(resolve => {
      getModuleListAuth().then(res => {
        if (res.Code === 200) {
          var index = res.Data.findIndex(item => item.ID === menuId)
          if (index == -1) {
            resolve(false)
          } else {
            resolve(true)
          }
        } else {
          resolve(false)
        }
      }).catch(error => {
        resolve(false)
      })


      checkMenuAuth({
        moduleID: menuId
      }).then(res => {
        if (res.Code === 200) {
          commit('mSetAuthButtons', res.Data.Actions)
          commit('mSetAuthOrgData', res.Data.DeptTree)
          resolve(res.Data.Flag)
        } else {

          resolve(false)
        }
      }).catch(error => {
        resolve(false)
      })


    })
  },

  //根据用户ID获取最新的申请审核记录
  aGetReviewBindingEnterpriseByUserID() {
    return new Promise(resolve => {
      GetReviewBindingEnterpriseByUserID().then(res => {
        if (res.Code === 200) {
          resolve(res.Data)
        } else {
          resolve(res.Data)
        }
      }).catch(error => {
        resolve(error)
      })
    })
  },


  aClearAll({
    commit
  }) {
    commit('mRemoveRouters');
    //清理当前顶级菜单id
    commit('mSetModuleID', '');
    //初始化加载菜单状态
    commit('mSetHasAuthorized', false);
  },
  aSetModuleID({
    commit
  }, moduleID) {
    commit('mSetModuleID', moduleID);
  }
}

// 递归遍历数据，构造路由数据
var routerArr = [];

function getRouterData(data) {
  data.forEach(item => {
    if (!item.URL) {
      item.children.forEach(itemdata => {
        notchildren(itemdata);
      });
    } else {
      if (item.URL && item.children && item.children.length == 0) {
        let obj = {};
        obj.path = item.URL;
        obj.name = item.Name;
        obj.component = loadView(item.AssemblyUrl);
        obj.meta = {
          menuID: item.ID,
          title: item.Name,
          needAuth: item.IsPermissions == 'Y' ? true : false,
          layout: item.Remark
        };
        obj.children = [];
        routerArr.push(obj);
      } else {
        var res = getchildrendata(item);
        routerArr.push(res);
      }
    }
  });
}

function notchildren(item) {
  if (!item.URL) {
    item.children.forEach(itemdata => {
      notchildren(itemdata);
    });
  } else {
    let objdata = [];
    objdata.path = item.URL;
    objdata.name = item.Name;
    objdata.component = loadView(item.AssemblyUrl);
    if (item.Keyword) {
      objdata.redirect = item.Keyword;
    }
    objdata.meta = {
      menuID: item.ID,
      title: item.Name,
      needAuth: item.IsPermissions == 'Y' ? true : false,
      layout: item.Remark
    };
    objdata.children = [];
    if (item.children.length > 0) {
      item.children.forEach(itemdata => {
        objdata.children.push(getchildrendata(itemdata));
      });
    }
    routerArr.push(objdata);
  }
}

function getchildrendata(item) {
  let objdata = [];
  objdata.path = item.URL;
  objdata.name = item.Name;
  objdata.component = loadView(item.AssemblyUrl);
  if (item.Keyword) {
    objdata.redirect = item.Keyword;
  }
  objdata.meta = {
    menuID: item.ID,
    title: item.Name,
    needAuth: item.IsPermissions == 'Y' ? true : false,
    layout: item.Remark
  };
  objdata.children = [];
  if (item.children.length > 0) {
    item.children.forEach(childrenitem => {
      objdata.children.push(getchildrendata(childrenitem));
    });
  }
  return objdata;
}


export default {
  namespaced: true,
  state,
  mutations,
  actions
}



// WEBPACK FOOTER //
// ./src/store/modules/permission.js